export const testimonials = [
	{
		name: 'Patricia Ojora',
		location: 'Founder, Promo Prints Ventures (Project Implementing Partner)',
		testimonial:
			'Working on this project made me realize that with dedication and commitment, our team is able to achieve great results within a timeframe.',
        image: 'https://res.cloudinary.com/dpabcunnn/image/upload/v1626990067/videos/patricia-thumbnail_fv1nfv.png',
        hasVideo: true,
		videoLink: 'https://youtu.be/zZHTILYQMtI?t=379',
		caption: "Promo Prints Founder speaks about the project's impact on her business.",
	},
	{
		name: 'Mrs. Akinwale Abiodun',
		location: 'Principal, Bishop Philip Academy Junior (Beneficiary)',
		testimonial:
			'Our students are fond of sharing facemasks, either because they misplace them or are unable to afford one. With Project SafeUp face masks, the students will be able to use clean masks and have an extra one.',
		image: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626130133/safeup/testimonials/bishop-grammar_1_pmjlyn.jpg',
		caption: 'Our Research Assistant, Mayowa, delivering masks to the school.',
	},
	{
		name: 'Mrs Ibiriri',
		location: 'Principal, Community Junior Grammar School (Beneficiary)',
		testimonial:
			"[Before Project SafeUp], some parents couldn't afford to provide face masks for their children and even the ones they had were either torn, dirty or worn multiple times without washing.",
		image: 'https://res.cloudinary.com/dqyhh2jit/image/upload/v1626129528/safeup/testimonials/alimosho_irxaou.jpg',
		caption: 'Students of Community Junior Grammar School wearing SafeUp masks.',
	},
	{
		name: 'Rolake Fadairo',
		location: 'Founder, Cute Cuts (Implementing Partner)',
        image: 'https://res.cloudinary.com/dpabcunnn/image/upload/v1627136112/videos/rolake-cute-cut_wim9nk.png',
		testimonial:
			'Working with Project SafeUp has led to an increase in staff strength and machineries. Through this project, I have been able to learn key management skills that have led to business efficiency.',
        hasVideo: true,
        videoLink: 'https://youtu.be/zZHTILYQMtI?t=299',
        caption: "Cute Cut Founder speaks about the project's impact on her business.",
	},
	{
		name: 'Mrs Abiodun Omotosho',
		location: 'Sasa Community Senior High School (Beneficiary)',
		testimonial:
			'Project SafeUp is highly commendable towards curbing the COVID-19 virus. We are grateful that all our students will be kept safe.',
		image: `https://res.cloudinary.com/dqyhh2jit/image/upload/v1625836287/safeup/ppe/masks_c88hx8.jpg`,
		caption: 'Students of Sasa Community Senior High School posing in their SafeUp masks.',
	},
	{
		name: 'Mrs Adeyemo',
		location: 'Principal, Moremi High School (Beneficiary)',
		testimonial:
			'At our school, many students had been found to be sharing face masks, and in some cases, wearing makeshift masks (from handkerchiefs or cloth) or wearing torn masks. With the Project SafeUp masks there would be drastic reduction in facemasks sharing amongst students.',
	},
	{
		name: 'Ago Tapa Primary Health Centre',
		location: 'Ibadan, Oyo',
		testimonial:
			'As the matron of Ago Tapa PHC, I would like to commend the great work of Project SafeUp. My staff and I are so excited to try on the PPE  given to us. The scrubs, shoe cover, and gowns are of really great quality. Thank you so much Project SafeUp.',
	},
	{
		name: 'Mrs Ogunremi',
		location: 'Fajuyi Primary Health Center (Beneficiary)',
		testimonial:
			'The PPE given to us by your organization would be used to avoid blood splashing when attending to our patients during surgery, and also prevent us from coronavirus . . . this PPE came at the right time as we have none available at the moment.',
	},
    {
        name: 'Omotayo Idongesit',
        location: 'Bloomlife Development Initiative (Beneficiary)',
        testimonial: '... With My World of Bags and the Mastercard Foundation\'s initiative, giving us this PPE . . . Wow! I can go anywhere. It has really opened great doors for us. Things that we thought we couldn\'t do before, it\'s just going smoothly. I\'m so grateful.'
    },
	{
		name: 'Osun State University Teaching Hospital',
		location: 'Osogbo, Osun',
		testimonial:
			'I just want to express my gratitude to Project SafeUp and Mastercard Foundation. The hospital administration had made plans to contract PPE production for the entire hospital which would have cost us an arm and a leg. Project SafeUp has not only saved us money, [but] has also saved time and lives.',
	},
];
